/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import ErrorCard from 'assets/images/error_card.svg';
import { ApplicationState } from 'store';
import { useSelector } from 'react-redux';
import { UpdateSaleState } from 'store/modules/update_sales_store/types';
import { CreateSaleState } from 'store/modules/create_sales_store/types';
import { openSupportChat } from 'services/support_chat';

interface ErrorCardModalProps {
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  showModal: boolean;
  typeSale: string;
  saleService: string;
}

const ErrorCardModal = (props: ErrorCardModalProps) => {
  const { setShowModal, showModal, typeSale, saleService } = props;
  const { update_sale } = useSelector<ApplicationState, UpdateSaleState>(
    (state) => state.session.update_sale,
  );
  const { create_sale } = useSelector<ApplicationState, CreateSaleState>(
    (state) => state.session.create_sale,
  );
  const handleClose = () => setShowModal(false);

  useEffect(() => {
    if (!showModal) {
      saleService === 'register'
        ? (window.location.href = '/painel')
        : (window.location.href = '/planos');
    }
  }, [showModal]);

  return (
    <Modal show={showModal}>
      <div className="col-md-12 text-center">
        <div className="p-5" style={{ width: '455px' }}>
          <img
            className="text-center"
            src={ErrorCard}
            alt="Imagem error"
            style={{ width: '120px' }}
          />
          <div className="card-body">
            <h5 className="card-title text-danger font-weight-bold mb-0">Ops! Algo deu errado.</h5>
            <p className="font-weight-bold">
              retorno da operadora: erro{' '}
              {typeSale === 'create_sale' ? create_sale.return_code : update_sale.return_code}
            </p>
            <span className="card-text mt-1 ">Por favor, tente fazer a compra novamente.</span>
            <br />
            <span className="card-text mt-0">
              Se o problema persistir, entre em contato com o nosso atendimento.
            </span>
          </div>
          <div>
            <button
              type="button"
              className="btn btn-primary btn-block "
              onClick={() => handleClose()}
            >
              Voltar
            </button>
            <button
              type="button"
              className="btn btn-link m-0 p-0 btn-block mt-2"
              onClick={() => {
                openSupportChat();
              }}
            >
              Falar com um consultor
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ErrorCardModal;
